import React from 'react'

export const DI_NOTIFICATION = {
  integration: {
    code: 'integration_di_notification',
    header: 'Just a heads up! ',
    text: (date) => (
      <div>
        You have untill <b>{date}</b> to make changes before you&#39;re unable to and we can
        finalize <b>Vision</b> for you.
      </div>
    )
  },
  ingesting: {
    code: 'ingesting_di_notification',
    header: 'Just a heads up! ',
    text: () => (
      <div>
        You&#39;ve past the period where you can make change and now we&#39;re working on setting up{' '}
        <b>Vision</b> to you.
      </div>
    )
  },
  assessed: {
    code: 'assessed_di_notification',
    header: 'Just a heads up. ',
    text: () => (
      <div>
        Enjoying your Assess plan and want to enjoy more of the Elevate Platform, reach out to our{' '}
        <b style={{ color: '#0C7D84' }}>
          <a href="mailto:inbound@elevatesecurity.com">Sales Team</a>
        </b>
        .
      </div>
    )
  }
}

export const HOME_NOTIFICATION = {
  integration: {
    code: 'integration_home_notification',
    header: 'Integration in progress',
    text: (date) => (
      <div>
        You have until <b>{date}</b> to make changes before you&#39;re unable to and we can finalize{' '}
        <b>Vision</b> for you.
      </div>
    )
  },
  ingesting: {
    code: 'ingesting_home_notification',
    header: 'Just a heads up! ',
    text: () => (
      <div>
        You&#39;ve past the period where you can make change and now we&#39;re working on setting up{' '}
        <b>Vision</b> to you.
      </div>
    )
  },
  assessed: {}
}

export const INDIVIDUALS_NOTIFICATION = {
  integration: {
    code: 'integration_individuals_notification',
    header: 'Just a heads up!',
    text: (
      <div>
        You&#39;ve successfully uploaded your HR file and you have until <b>(Data)</b> to make
        change to your Individuals list.
      </div>
    )
  },
  ingesting: {
    code: 'ingesting_individuals_notification',
    header: 'Just a heads up! ',
    text: (
      <div>
        You&#39;ve past the period where you can make change and now we&#39;re working on setting up{' '}
        <b>Vision</b> to you.
      </div>
    )
  },
  assessed: {}
}

export const GLOBAL_NOTIFICATION = {
  integration: {},
  ingesting: {},
  assessed: {
    code: 'assessed_global_notification',
    header: 'Access period is running out. ',
    text: (date, remainingDays) => (
      <div>
        Assess plan is running out on <b>{date}</b>, less than <b>{remainingDays}</b> days away.{' '}
        <a href="mailto:inbound@elevatesecurity.com" style={{ color: '#0c7d84' }}>
          <b>Reach out</b>
        </a>{' '}
        to our Customer Success team to upgrade.
      </div>
    )
  }
}
